import { createContext } from 'react';

export const MentorSetupContext = createContext(null)